import * as devisConf from '@/configuration/devisConf';

export default function calculLignePersonnalise(ligneCommande, lignesCommande) {
  if (!ligneCommande || ligneCommande.type !== devisConf.PERSONNALISE
    || !lignesCommande || !lignesCommande.length === 0) {
    return;
  }
  const lignesNormalesRegroupees = lignesCommande.filter(ligne => ligne.type === devisConf.NORMAL
    && ligne.referencePersonnalise === ligneCommande.referencePersonnalise);

  // champs fixes
  ligneCommande.quantite = 1;
  ligneCommande.remise = 0;
  ligneCommande.typeRemise = devisConf.POURCENTAGE;
  ligneCommande.uniteVente = devisConf.UNITE;
  // champs liés aux lignes regroupees
  ligneCommande.prixUnitaire = lignesNormalesRegroupees.reduce(
    (acc, ligne) => acc + ligne.totalHt,
    0,
  );
  ligneCommande.totalHt = ligneCommande.prixUnitaire;
  ligneCommande.totalAvantRemise = ligneCommande.prixUnitaire;
  ligneCommande.totalHtAvecLigneRemise = ligneCommande.prixUnitaire;
  if (lignesNormalesRegroupees.length === 0) return;
  ligneCommande.tauxTva = lignesNormalesRegroupees[0].tauxTva;
}
